import StorageHistory from './StorageHistory';

export default StorageHistory;